import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tab, Tabs } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import Wrapper from '../../dashboardWrapper/Wrapper'
import PasswordReset from './PasswordReset'
import './style.scss'
import UserForm from './UserForm'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import UserInfo from './UserInfo'

const Account = () => {
    let userdata = JSON.parse(localStorage.getItem("user"))
    const {t} = useTranslation();

    return (
        <Wrapper>
            <DashboardContent>
                <DashboardMainTitle>{t("dashboard_nav_user_account")}</DashboardMainTitle>
                {userdata &&
                    userdata.role === "DEVELOPER" ?
                        <Tabs defaultActiveKey="twoStep" id="profile-tab">
                            <Tab eventKey="twoStep" title={t("two step verification")}>
                                <UserForm />
                            </Tab>
                            <Tab eventKey="password" title={t("password")}>
                                <PasswordReset />
                            </Tab>
                        </Tabs>
                    :
                        <Tabs defaultActiveKey="profile" id="profile-tab">
                            <Tab eventKey="profile" title={t("profile")}>
                                <UserInfo />
                            </Tab>
                            <Tab eventKey="twoStep" title={t("two step verification")}>
                                <UserForm />
                            </Tab>
                            <Tab eventKey="password" title={t("password")}>
                                <PasswordReset />
                            </Tab>
                        </Tabs>
                }
            </DashboardContent>
        </Wrapper>
    )
}

export default withRouter(Account)
